'use client';

import React from 'react';

export const PopoverStatusContext = React.createContext({ isShowing: false });
